import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useNavigate, Navigate, useLocation } from 'react-router-dom';
import AddProduct from './AddProduct';
import Login from './Login';
import AdminOrders from './components/AdminOrders';
import AdminProducts from './components/AdminProducts';
import AdminDashboard from './components/AdminDashboard';
import AdminSellers from './components/AdminSellers';
import AdminCustomers from './components/AdminCustomers';
import AdminPromotions from './components/AdminPromotions';
import { trackDashboardUsage } from './utils/analytics';

function AdminPanel() {
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = location.pathname.startsWith('/super-admin') ? '/super-admin' : '/admin';

  useEffect(() => {
    const token = localStorage.getItem('admin-token');
    setIsAdmin(!!token);
  }, [location.pathname]);

  useEffect(() => {
    if (!isAdmin) return;
    const section = location.pathname.replace(`${basePath}/`, '') || 'dashboard';
    trackDashboardUsage({
      role: 'super_admin',
      section,
      path: location.pathname,
    });
  }, [basePath, isAdmin, location.pathname]);

  const handleLogin = (token) => {
    localStorage.removeItem('customer');
    localStorage.removeItem('seller');
    localStorage.removeItem('seller-token');
    localStorage.removeItem('customer-token');
    localStorage.removeItem('customer-id');
    localStorage.removeItem('customer-name');
    localStorage.setItem('admin-token', token);
    setIsAdmin(true);
    navigate(`${basePath}`);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin-token');
    setIsAdmin(false);
    navigate(`${basePath}/login`);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%)' }}>
      <nav
        style={{
          padding: '14px 20px',
          background: '#0f172a',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 12,
        }}
      >
        <div>
          <div style={{ fontSize: 20, fontWeight: 800 }}>Super Admin Console</div>
          <div style={{ fontSize: 13, color: '#cbd5e1' }}>
            Create sellers, monitor sales, manage orders, and run the marketplace.
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
        <Link to={basePath} style={navLink}>Dashboard</Link>
        {isAdmin && (
          <>
            <Link to={`${basePath}/sellers`} style={navLink}>Sellers</Link>
            <Link to={`${basePath}/customers`} style={navLink}>Customers</Link>
            <Link to={`${basePath}/orders`} style={navLink}>Orders</Link>
            <Link to={`${basePath}/products`} style={navLink}>Products</Link>
            <Link to={`${basePath}/promotions`} style={navLink}>Offers</Link>
            <Link to={`${basePath}/add-product`} style={navLink}>New Listing</Link>
            <button onClick={handleLogout} style={logoutButton}>Logout</button>
          </>
        )}
        </div>
      </nav>

      <Routes>
        {!isAdmin ? (
          <>
            <Route
              path="login"
              element={
                <Login
                  onLogin={handleLogin}
                  title="Super Admin Login"
                  subtitle="Access the owner dashboard for seller creation, reports, and marketplace control."
                />
              }
            />
            <Route path="*" element={<Navigate to={`${basePath}/login`} />} />
          </>
        ) : (
          <>
            <Route path="" element={<AdminDashboard />} />
            <Route path="add-product" element={<AddProduct />} />
            <Route path="sellers" element={<AdminSellers />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="promotions" element={<AdminPromotions />} />
            <Route path="*" element={<Navigate to={basePath} />} />
          </>
        )}
      </Routes>
    </div>
  );
}

const navLink = {
  textDecoration: 'none',
  color: '#e2e8f0',
  background: 'rgba(255,255,255,0.08)',
  padding: '9px 14px',
  borderRadius: 999,
  fontWeight: 700,
};

const logoutButton = {
  background: '#ef4444',
  color: '#fff',
  border: 'none',
  padding: '9px 14px',
  borderRadius: 999,
  fontWeight: 700,
  cursor: 'pointer',
};

export default AdminPanel;
